import { defineStore } from 'pinia';

export const useHeaderAttributesStore = defineStore('headerAttributes', () => {
    const headerBackground = ref<string>('white');
    const headerTextTheme = ref<string>('');
    const scrollingUp = ref<boolean>(false);
    const isHeaderScrolledToTop = ref<boolean>(true);
    const isCondensed = ref<boolean>(false);
    const isCondensedOverride = ref<boolean>(false);
    const openTopicModal = ref<boolean>(false);
    const openRegionModal = ref<boolean>(false);

    function updateHeaderStyleAttributes({ background, text = '', condensed = false, condensedOverride = false }: { background: string; text?: string; condensed?: boolean; condensedOverride?: boolean }) {
        headerBackground.value = background;
        headerTextTheme.value = text;
        if (condensedOverride) {
            isCondensed.value = true;
            isCondensedOverride.value = true;
        } else {
            isCondensed.value = condensed;
        }
    }

    function updateHeaderScrollAttributes(direction = 'down', top = false) {
        scrollingUp.value = direction === 'up';
        isHeaderScrolledToTop.value = top;
    }

    return {
        headerBackground,
        headerTextTheme,
        scrollingUp,
        isHeaderScrolledToTop,
        isCondensed,
        isCondensedOverride,
        openTopicModal,
        openRegionModal,
        updateHeaderStyleAttributes,
        updateHeaderScrollAttributes,
    };
});
